import { Contactable, Dto } from '@damofire/data-commons';
import { PartialOrganization } from './organization.dto';
import { Representative } from './user.dto';

export enum MoveStatus {
  START = 'start',
  MOVING = 'moving',
  FINALIZE = 'finalize',
  CLEANUP = 'cleanup',
  DONE = 'done',
  DONE_WITH_ERRORS = 'done-with-errors',
}

export interface MoveMetadata {
  filesRemaining?: number;
  fileEstimate?: number;
  status?: MoveStatus;
}

export interface Movable {
  moveMetadata?: MoveMetadata;
}
export interface Division extends Dto<string>, Contactable, Movable {
  name?: string;
  enabled?: boolean;
  deleteMe?: boolean;
  organization?: PartialOrganization;
  types?: string[];
  users?: number;
  principal?: boolean;
  taxId?: string;
  representatives?: Representative[];
  statistics?: DivisionStatictics;
}

export interface DivisionStatictics extends Record<string, unknown> {
  inspections?: DivisionInspectionStatistics;
}

export interface DivisionInspectionStatistics {
  damo?: number;
  self?: number;
}
